import React, { useState } from 'react';
import { Lock, Loader2 } from 'lucide-react';
import { Button } from './ui/button';
import { Input } from './ui/input';
import { submitSiteGate } from '../lib/api';

export default function SiteGate({ onPassed }) {
  const [password, setPassword] = useState('');
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await submitSiteGate(password);
      onPassed();
    } catch (err) {
      const msg = err?.response?.data?.detail || "Code d'accès invalide";
      setError(msg);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-background flex items-center justify-center px-6">
      <div className="w-full max-w-sm bg-card border border-border rounded-xl p-8 shadow-xl">
        <div className="flex flex-col items-center text-center mb-6">
          <div className="w-12 h-12 rounded-xl bg-primary/10 flex items-center justify-center mb-4">
            <Lock className="w-5 h-5 text-primary" />
          </div>
          <h1 className="text-lg font-semibold tracking-tight">Accès Kinote</h1>
          <p className="text-sm text-muted-foreground mt-1.5">
            Ce site est protégé. Entrez le code pour continuer.
          </p>
        </div>

        <form onSubmit={handleSubmit} className="space-y-3" data-testid="site-gate-form">
          <Input
            type="password"
            placeholder="Code d'accès"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            className="h-10 text-sm"
            autoFocus
            required
            data-testid="site-gate-input"
          />
          {error && (
            <p className="text-xs text-destructive" data-testid="site-gate-error">{error}</p>
          )}
          <Button
            type="submit"
            disabled={loading || !password}
            className="w-full h-10 font-medium text-sm"
            data-testid="site-gate-submit"
          >
            {loading ? <Loader2 className="w-4 h-4 animate-spin" /> : 'Continuer'}
          </Button>
        </form>
      </div>
    </div>
  );
}
